import {
  Component,
  NgZone,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import {
  RealtorPortalService
} from '../../../services/network/realtor-portal.service';



@Component({
  templateUrl: './view-coverage.component.html',
  styleUrls: ['./view-coverage.component.css'],
})
export class ViewCoverageDialogComponent {
  planDetail: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog,
              private customerPortalService: RealtorPortalService) {
    const planItemId: string = data;


    this.customerPortalService.getContractLanguage(planItemId)
        .then(detail => {
          this.planDetail = detail;
          this.htmlFormatLanguage();
        });
  }

  private htmlFormatLanguage() {
    this.planDetail.CoveredLanguage =
        this.replaceAll(this.planDetail.CoveredLanguage, '\n', '<br/>');
    this.planDetail.CoveredLanguage =
        this.replaceAll(this.planDetail.CoveredLanguage, '<indent>',
                        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

    this.planDetail.NotCoveredLanguage =
        this.replaceAll(this.planDetail.NotCoveredLanguage, '\n', '<br/>');
    this.planDetail.NotCoveredLanguage =
        this.replaceAll(this.planDetail.NotCoveredLanguage, '<indent>',
                        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

    this.planDetail.LimitsLanguage =
        this.replaceAll(this.planDetail.LimitsLanguage, '\n', '<br/>');
    this.planDetail.LimitsLanguage =
        this.replaceAll(this.planDetail.LimitsLanguage, '<indent>',
                        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
  }

  private escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  }

  private replaceAll(str, find, replace) {
    if (str == null) {
      str = '';
    }
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }
}
